import { cn } from "@/lib/cn";

/**
 * Think Big Techies mark — an ascending "think big" spark inside a soft ring.
 * Editorial: warm ring, gradient spark, serif wordmark.
 */
export function Logo({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <span className="relative grid size-9 shrink-0 place-items-center rounded-full border border-foreground/12 bg-background shadow-editorial">
        <svg viewBox="0 0 24 24" className="size-5" fill="none" aria-hidden>
          <defs>
            <linearGradient id="tbt-spark" x1="4" y1="20" x2="20" y2="4" gradientUnits="userSpaceOnUse">
              <stop stopColor="hsl(var(--primary))" />
              <stop offset="1" stopColor="hsl(var(--accent))" />
            </linearGradient>
          </defs>
          {/* ascending bars = "think big" growth */}
          <rect x="4" y="13" width="3.4" height="7" rx="1.4" fill="url(#tbt-spark)" opacity="0.55" />
          <rect x="10.3" y="9" width="3.4" height="11" rx="1.4" fill="url(#tbt-spark)" opacity="0.8" />
          <rect x="16.6" y="4.5" width="3.4" height="15.5" rx="1.4" fill="url(#tbt-spark)" />
          {/* spark */}
          <circle cx="6.6" cy="7.5" r="1.7" fill="hsl(var(--accent))" />
        </svg>
        <span aria-hidden className="absolute -inset-0.5 -z-10 rounded-full bg-accent/25 blur-md" />
      </span>
      {showWordmark && (
        <span className="font-serif text-lg leading-none tracking-tight">
          Think Big <span className="italic text-muted-foreground">Techies</span>
        </span>
      )}
    </div>
  );
}
